const pageNameKey = "backIconButtonWithText";

export const backIconButtonWithTextEn = {
  [pageNameKey]: {
    backButtonAltText: "Back",
  },
};

export const backIconButtonWithTextPtBr = {
  [pageNameKey]: {
    backButtonAltText: "Voltar",
  },
};

export const backIconButtonWithTextDe = {
  [pageNameKey]: {
    backButtonAltText: "Zurück",
  },
};

export const backIconButtonWithTextZhHans = {
  [pageNameKey]: {
    backButtonAltText: "返回",
  },
};

export const backIconButtonWithTextIt = {
  [pageNameKey]: {
    backButtonAltText: "Indietro",
  },
};

export const backIconButtonWithTextEs = {
  [pageNameKey]: {
    backButtonAltText: "Atrás",
  },
};

export const backIconButtonWithTextNl = {
  [pageNameKey]: {
    backButtonAltText: "Terug",
  },
};

export const backIconButtonWithTextTr = {
  [pageNameKey]: {
    backButtonAltText: "Geri",
  },
};
